<template>
  <a-modal
    :title="modalTit"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :centered="true"
    :mask-closable="false"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <h3>{{ $t('message["780"]') }}：</h3>
    <a-form
      :form="form"
      :hide-required-mark="true"
    >
      <a-form-item>
        <a-input
          v-decorator="['reason', {
            rules: [{ required: true, message: rufuseReasonTip}],
            initialValue: reason || ''
          }]"
          :placeholder="enterPlaceholder"
          class="input"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inquiryReject } from '@/services/inqueryServices'

const FROM_SOPURCE = 'notice'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    },
    auditRoleid: {
      type: [String, Number],
      default: () => { }
    },
    auditGroupid: {
      type: [String, Number],
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      reason: ''
    }
  },
  computed: {
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    modalTit () {
      return this.$t('message["542"]')
    },
    rufuseReasonTip () {
      return this.$t('message["546"]')
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    hide () {
      this.$emit('update:visible', false)
    },
    async handleOk () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          if (this.confirmLoading) return

          this.confirmLoading = true

          this.reason = this.form.getFieldValue('reason')

          const chain = await inquiryReject()
          chain
            .params({
              inquiryid: parseInt(this.inquiryId),
              reason: this.reason,
              audit_roleid: this.auditRoleid,
              audit_groupid: this.auditGroupid
            })
            .onNetSuccess(raw => {
              this.confirmLoading = false
              this.handleCancel()
            })
            .onSuccess(payload => {
              /* this.$router.push({
                name: 'InqueryAudit',
                query: {
                  type: this.type,
                  from: this.from
                }
              }) */
              if (this.from === FROM_SOPURCE) {
                this.$router.push({ name: 'recordNotice' })
              } else if (this.from === 'webhook') {
                this.$router.push({
                  name: 'configSendRecord',
                  params: {
                    hookid: this.$route.query.hookid
                  }
                })
              } else if (this.from === 'clue') {
                this.$router.push({
                  name: 'InqueryClue'
                })
              } else if (this.from === 'ocpc') {
                this.$router.push({
                  name: 'ocpc'
                })
              } else {
                if (this.from === 'audit') {
                  this.$router.push({
                    name: 'InqueryAudit',
                    query: {
                      type: this.type || 'wait-audit',
                      from: this.from
                    }
                  })
                } else {
                  this.$router.push({
                    name: 'InqueryList',
                    query: {
                      type: this.type,
                      from: this.from
                    }
                  })
                }
              }
            })
            .fetch()
        }
      })
    },
    handleCancel () {
      this.hide()
      this.form.resetFields()
      this.reason = ''
      this.confirmLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input {
  margin: 20px 0;
}
</style>
